import React from 'react';
import { StyledBingoPopSubProduct, StyledSubContainer } from './styles';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { ProductData } from 'utils/types';
import { Divider } from '@mui/material';

export type IBingoPopSubProductsProps = {
  products: ProductData[];
};

export const BingoPopSubProducts: React.FC<IBingoPopSubProductsProps> = ({
  products,
}) => (
  <>
    <Divider orientation="vertical" className={'types-divider'} />
    <StyledSubContainer>
      {products.map((sub) => (
        <StyledBingoPopSubProduct textColor={sub.textFontColorHex}>
          <div className="image-container">
            <img src={sub.images.product} alt="product" className="image" />
          </div>
          <span className="quantity">
            <AutoTextSize maxFontSizePx={18} minFontSizePx={6} mode="oneline">
              {sub.quantityDisplay}
            </AutoTextSize>
          </span>
        </StyledBingoPopSubProduct>
      ))}
    </StyledSubContainer>
  </>
);
